module.exports = __webpack_public_path__ + "img/service.69bc7090.jpg";